import Crud from '../components/ViewingGroups/Crud'

let routes = {
    path: '/users',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/signature_viewing_groups/:operation?/:id?',
          name: 'Grupos de Visualização',
          component: Crud
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/viewingGroups.js